// src/routes.js
import TransaksiPembelianTanah from "pages/PembelianTanah";
import React from "react";
import { Navigate } from "react-router-dom";
// Hapus import yang tidak perlu (Layout dan JurnalSaldoAwalLayout static)
// import Layout from "store/layout/reducer"; 

// =========================================================================
//                       DEFINISI IMPORT DINAMIS (LAZY LOADING)
// =========================================================================

// Pages Component
const Chat = React.lazy(() => import("../pages/Chat/Chat"));
const FileManager = React.lazy(() => import("../pages/FileManager/index"));
const UserProfile = React.lazy(() => import("../pages/Authentication/user-profile"));
const Calendar = React.lazy(() => import("../pages/Calendar/index"));
const TasksList = React.lazy(() => import("../pages/Tasks/tasks-list"));
const TasksCreate = React.lazy(() => import("../pages/Tasks/tasks-create"));
const TasksKanban = React.lazy(() => import("../pages/Tasks/tasks-kanban"));
const ProjectsGrid = React.lazy(() => import("../pages/Projects/projects-grid"));
const ProjectsList = React.lazy(() => import("../pages/Projects/projects-list"));
const ProjectsOverview = React.lazy(() => import("../pages/Projects/ProjectOverview/projects-overview"));
const ProjectsCreate = React.lazy(() => import("../pages/Projects/projects-create"));
const ProjectDetail = React.lazy(() => import("pages/Projects/ProjectOverview/projectDetail"));

//Ecommerce Pages
const EcommerceProducts = React.lazy(() => import("../pages/Ecommerce/EcommerceProducts"));
const EcommerceProductDetail = React.lazy(() => import("../pages/Ecommerce/EcommerceDetails/index"));
const EcommerceOrders = React.lazy(() => import("../pages/Ecommerce/EcommerceOrders/index"));
const EcommerceCustomers = React.lazy(() => import("../pages/Ecommerce/EcommerceCustomers/index"));
const EcommerceCart = React.lazy(() => import("../pages/Ecommerce/EcommerceCart"));
const EcommerceCheckout = React.lazy(() => import("../pages/Ecommerce/EcommerceCheckout"));
const EcommerceShops = React.lazy(() => import("../pages/Ecommerce/EcommerceShops/index"));
const EcommerceAddProduct = React.lazy(() => import("../pages/Ecommerce/EcommerceAddProduct"));

//Email
const EmailInbox = React.lazy(() => import("../pages/Email/email-inbox"));
const EmailRead = React.lazy(() => import("../pages/Email/email-read"));
const EmailBasicTemplte = React.lazy(() => import("../pages/Email/email-basic-templte"));
const EmailAlertTemplte = React.lazy(() => import("../pages/Email/email-template-alert"));
const EmailTemplateBilling = React.lazy(() => import("../pages/Email/email-template-billing"));

//Invoices
const InvoicesList = React.lazy(() => import("../pages/Invoices/invoices-list"));
const InvoiceDetail = React.lazy(() => import("../pages/Invoices/invoices-detail"));

// Authentication related pages (Public Routes)
const Login = React.lazy(() => import("../pages/Authentication/Login"));
const Logout = React.lazy(() => import("../pages/Authentication/Logout"));
const Register = React.lazy(() => import("../pages/Authentication/Register"));
const ForgetPwd = React.lazy(() => import("../pages/Authentication/ForgetPassword"));
const ResetPassword = React.lazy(() => import("pages/Authentication/ResetPassword"));
const KonfirmasiEmail = React.lazy(() => import("pages/Authentication/KonfirmasiEmail"));

// Inner Authentication (Public Routes)
const Login1 = React.lazy(() => import("../pages/AuthenticationInner/Login"));
const Login2 = React.lazy(() => import("../pages/AuthenticationInner/Login2"));
const Register1 = React.lazy(() => import("../pages/AuthenticationInner/Register"));
const Register2 = React.lazy(() => import("../pages/AuthenticationInner/Register2"));
const Recoverpw = React.lazy(() => import("../pages/AuthenticationInner/Recoverpw"));
const Recoverpw2 = React.lazy(() => import("../pages/AuthenticationInner/Recoverpw2"));
const ForgetPwd1 = React.lazy(() => import("../pages/AuthenticationInner/ForgetPassword"));
const ForgetPwd2 = React.lazy(() => import("../pages/AuthenticationInner/ForgetPassword2"));
const LockScreen = React.lazy(() => import("../pages/AuthenticationInner/auth-lock-screen"));
const LockScreen2 = React.lazy(() => import("../pages/AuthenticationInner/auth-lock-screen-2"));
const ConfirmMail = React.lazy(() => import("../pages/AuthenticationInner/page-confirm-mail"));
const ConfirmMail2 = React.lazy(() => import("../pages/AuthenticationInner/page-confirm-mail-2"));
const EmailVerification = React.lazy(() => import("../pages/AuthenticationInner/auth-email-verification"));
const EmailVerification2 = React.lazy(() => import("../pages/AuthenticationInner/auth-email-verification-2"));
const TwostepVerification = React.lazy(() => import("../pages/AuthenticationInner/auth-two-step-verification"));
const TwostepVerification2 = React.lazy(() => import("../pages/AuthenticationInner/auth-two-step-verification-2"));
const VerifikasiEmail = React.lazy(() => import("../pages/AuthenticationInner/verifikasi-email"));
const VerifikasiEmailReset = React.lazy(() => import("../pages/AuthenticationInner/verifikasi-email-reset"));

// Dashboard
const Dashboard = React.lazy(() => import("../pages/Dashboard/index"));
const Panduan = React.lazy(() => import("../pages/Panduan"));
const DashboardSaas = React.lazy(() => import("../pages/Dashboard-saas/index"));
const DashboardCrypto = React.lazy(() => import("../pages/Dashboard-crypto/index"));
const Blog = React.lazy(() => import("../pages/Dashboard-Blog/index"));
const DashboardJob = React.lazy(() => import("../pages/DashboardJob/index"));

//Crypto
const CryptoWallet = React.lazy(() => import("../pages/Crypto/CryptoWallet/crypto-wallet"));
const CryptoBuySell = React.lazy(() => import("../pages/Crypto/crypto-buy-sell"));
const CryptoExchange = React.lazy(() => import("../pages/Crypto/crypto-exchange"));
const CryptoLending = React.lazy(() => import("../pages/Crypto/crypto-lending"));
const CryptoOrders = React.lazy(() => import("../pages/Crypto/CryptoOrders/crypto-orders"));
const CryptoKYCApplication = React.lazy(() => import("../pages/Crypto/crypto-kyc-application"));
const CryptoIcoLanding = React.lazy(() => import("../pages/Crypto/CryptoIcoLanding/index"));

// Charts
const ChartApex = React.lazy(() => import("../pages/Charts/Apexcharts"));
const ChartjsChart = React.lazy(() => import("../pages/Charts/ChartjsChart"));
const EChart = React.lazy(() => import("../pages/Charts/EChart"));
const SparklineChart = React.lazy(() => import("../pages/Charts/SparklineChart"));
const ChartsKnob = React.lazy(() => import("../pages/Charts/charts-knob"));
const ReCharts = React.lazy(() => import("../pages/Charts/ReCharts"));

// Maps
const MapsGoogle = React.lazy(() => import("../pages/Maps/MapsGoogle"));

//Icons
const IconBoxicons = React.lazy(() => import("../pages/Icons/IconBoxicons"));
const IconDripicons = React.lazy(() => import("../pages/Icons/IconDripicons"));
const IconMaterialdesign = React.lazy(() => import("../pages/Icons/IconMaterialdesign"));
const IconFontawesome = React.lazy(() => import("../pages/Icons/IconFontawesome"));

//Tables
const BasicTables = React.lazy(() => import("../pages/Tables/BasicTables"));
const DatatableTables = React.lazy(() => import("../pages/Tables/DatatableTables"));

//Blog
const BlogList = React.lazy(() => import("../pages/Blog/BlogList/index"));
const BlogGrid = React.lazy(() => import("../pages/Blog/BlogGrid/index"));
const BlogDetails = React.lazy(() => import("../pages/Blog/BlogDetails"));

//Job
const JobGrid = React.lazy(() => import("../pages/JobPages/JobGrid/index"));
const JobDetails = React.lazy(() => import("../pages/JobPages/JobDetails"));
const JobCategories = React.lazy(() => import("../pages/JobPages/JobCategories"));
const JobList = React.lazy(() => import("../pages/JobPages/JobList"));
const ApplyJobs = React.lazy(() => import("../pages/JobPages/ApplyJobs/index"));
const CandidateList = React.lazy(() => import("../pages/JobPages/CandidateList"));
const CandidateOverview = React.lazy(() => import("../pages/JobPages/CandidateOverview"));

// Forms
const FormElements = React.lazy(() => import("../pages/Forms/FormElements"));
const FormLayouts = React.lazy(() => import("../pages/Forms/FormLayouts"));
const FormAdvanced = React.lazy(() => import("../pages/Forms/FormAdvanced"));
const FormEditors = React.lazy(() => import("../pages/Forms/FormEditors"));
const FormValidations = React.lazy(() => import("../pages/Forms/FormValidations"));
const FormMask = React.lazy(() => import("../pages/Forms/FormMask"));
const FormRepeater = React.lazy(() => import("../pages/Forms/FormRepeater"));
const FormUpload = React.lazy(() => import("../pages/Forms/FormUpload"));
const FormWizard = React.lazy(() => import("../pages/Forms/FormWizard"));

//Ui
const UiAlert = React.lazy(() => import("../pages/Ui/UiAlert"));
const UiButtons = React.lazy(() => import("../pages/Ui/UiButtons"));
const UiCards = React.lazy(() => import("../pages/Ui/UiCards"));
const UiCarousel = React.lazy(() => import("../pages/Ui/UiCarousel"));
const UiColors = React.lazy(() => import("../pages/Ui/UiColors"));
const UiDropdown = React.lazy(() => import("../pages/Ui/UiDropdown"));
const UiGeneral = React.lazy(() => import("../pages/Ui/UiGeneral"));
const UiGrid = React.lazy(() => import("../pages/Ui/UiGrid"));
const UiImages = React.lazy(() => import("../pages/Ui/UiImages"));
const UiLightbox = React.lazy(() => import("../pages/Ui/UiLightbox"));
const UiModal = React.lazy(() => import("../pages/Ui/UiModal"));
const UiProgressbar = React.lazy(() => import("../pages/Ui/UiProgressbar"));
const UiTabsAccordions = React.lazy(() => import("../pages/Ui/UiTabsAccordions"));
const UiTypography = React.lazy(() => import("../pages/Ui/UiTypography"));
const UiVideo = React.lazy(() => import("../pages/Ui/UiVideo"));
const UiSessionTimeout = React.lazy(() => import("../pages/Ui/UiSessionTimeout"));
const UiRating = React.lazy(() => import("../pages/Ui/UiRating"));
const UiRangeSlider = React.lazy(() => import("../pages/Ui/UiRangeSlider"));
const UiNotifications = React.lazy(() => import("../pages/Ui/ui-notifications"));
const UiOffCanvas = React.lazy(() => import("pages/Ui/UiOffCanvas"));
const UiUtilitie = React.lazy(() => import("../pages/Ui/UiUtilitie"));
const UiPlaceholders = React.lazy(() => import("../pages/Ui/UiPlaceholders"));
const UiToasts = React.lazy(() => import("../pages/Ui/UiToast"));

//Pages
const PagesStarter = React.lazy(() => import("../pages/Utility/pages-starter"));
const PagesMaintenance = React.lazy(() => import("../pages/Utility/pages-maintenance"));
const PagesComingsoon = React.lazy(() => import("../pages/Utility/pages-comingsoon"));
const PagesTimeline = React.lazy(() => import("../pages/Utility/pages-timeline"));
const PagesFaqs = React.lazy(() => import("../pages/Utility/pages-faqs"));
const PagesPricing = React.lazy(() => import("../pages/Utility/pages-pricing"));
const Pages404 = React.lazy(() => import("../pages/Utility/pages-404"));
const Pages500 = React.lazy(() => import("../pages/Utility/pages-500"));

//Contacts
const ContactsGrid = React.lazy(() => import("../pages/Contacts/contacts-grid"));
const ContactsList = React.lazy(() => import("../pages/Contacts/ContactList/contacts-list"));
const ContactsProfile = React.lazy(() => import("../pages/Contacts/ContactsProfile/contacts-profile"));

// Custom Pages
const RekeningBank = React.lazy(() => import("pages/Rekening"));
const Kategori = React.lazy(() => import("pages/Kategori"));
const SoalList = React.lazy(() => import("pages/Soal"));
const PaketSimulasi = React.lazy(() => import("pages/PaketSimulasi"));
const SubSimulasiDetail = React.lazy(() => import("pages/PaketSimulasi/SubSimulasiDetail"));
const PaketDetails = React.lazy(() => import("pages/PaketSimulasi/PaketDetails"));
const JenisSoal = React.lazy(() => import("pages/Soal/jenisSoal"));
const JenisSeleksi = React.lazy(() => import("pages/Master/JenisSeleksi"));
const FaseUjian = React.lazy(() => import("pages/Master/TipeKonten")); // Nama TipeKonten juga diimpor di bawah
const MasterJenisSoal = React.lazy(() => import("pages/Master/JenisSoal"));
const MasterPaket = React.lazy(() => import("pages/Master/Paket"));
const MasterTipeKonten = React.lazy(() => import("pages/Master/TipeKonten"));
const PaketDetailTryout = React.lazy(() => import("pages/Master/Paket/PaketDetailTryout"));
const VideoList = React.lazy(() => import("pages/Video/VideoList"));
const BacaanList = React.lazy(() => import("pages/Bacaan/BacaanList"));
const PaketBacaan = React.lazy(() => import("pages/PaketBacaan"));
const PaketDetailBacaan = React.lazy(() => import("pages/PaketBacaan/PaketDetailBacaan"));
const ListBacaan = React.lazy(() => import("pages/PaketBacaan/ListBacaan"));
const PaketVideo = React.lazy(() => import("pages/PaketVideo"));
const PaketDetailVideo = React.lazy(() => import("pages/PaketVideo/PaketDetailVideo"));
const ListVideo = React.lazy(() => import("pages/PaketVideo/ListVideo"));
const Produk = React.lazy(() => import("pages/Produk"));
const DetailProduk = React.lazy(() => import("pages/Produk/ProdukDetail"));
const PaketLanggananTryout = React.lazy(() => import("pages/Langganan"));
const SubPaketLangganan = React.lazy(() => import("pages/Langganan/SubPaketLangganan"));
const PaketLangganan = React.lazy(() => import("pages/Langganan/Produk"));
const KategoriSeleksi = React.lazy(() => import("pages/KategoriSeleksi"));
const User = React.lazy(() => import("pages/User"));
const Payments = React.lazy(() => import("pages/Payments"));
const ProdukKonten = React.lazy(() => import("pages/Produk/ProdukKonten"));
const SubVideoDetail = React.lazy(() => import("pages/PaketVideo/SubPaketVideo"));
const SubPaketBacaan = React.lazy(() => import("pages/PaketBacaan/SubPaketBacaan"));
const UpdateUser = React.lazy(() => import("pages/User/UpdateUser"));
const PaketRaportNasional = React.lazy(() => import("pages/RaportNasional"));
const SubPaketRaport = React.lazy(() => import("pages/RaportNasional/SubPaketRaport"));
const RiwayatRaport = React.lazy(() => import("pages/RaportNasional/RiwayatRaport"));
const PaketBimbel = React.lazy(() => import("pages/Langganan/bimbel"));
const KelasOnline = React.lazy(() => import("pages/KelasOnline"));
const UserKelasOnline = React.lazy(() => import("pages/KelasOnline/UserKelasOnline"));
const Supplier = React.lazy(() => import("pages/Supplier"));
const Supir = React.lazy(() => import("pages/Supir"));
const Product = React.lazy(() => import("pages/Product"));
const Penjualan = React.lazy(() => import("pages/Penjualan/ListPenjualan"));
const PenjualanLangsung = React.lazy(() => import("pages/Penjualan/PenjualanLangsung"));
const StockMutasi = React.lazy(() => import("pages/StokMutasi"));
const Jabatan = React.lazy(() => import("pages/Jabatan"));
const TipeJurnal = React.lazy(() => import("pages/TipeJurnal"));
const Coa = React.lazy(() => import("pages/Coa"));
const MasterJurnalLayout = React.lazy(() => import("pages/MasterJurnal/MasterJurnalLayout")); 
const JurnalUmumLayout = React.lazy(() => import("pages/Journal/JurnalUmumLayout"));
// ✅ PERBAIKAN: Menggunakan nama yang jelas untuk komponen Lazy Loaded
const JurnalSaldoAwalPage = React.lazy(() => import("pages/JurnalSaldoAwal/Layout")); 
const CoaDivisiMapping = React.lazy(() => import("pages/DivisiCoa"));
const Divisi = React.lazy(() => import("pages/Divisi"));
const Pengajuan = React.lazy(() => import("pages/Pengajuan/Layout")); // Import Pengajuan secara lazy
const MasterLokasi = React.lazy(() => import("pages/MasterLokasi"));
const MasterBlok = React.lazy(() => import("pages/MasterBlok"));
const MasterWorkFlowApproval = React.lazy(() => import("pages/WorkFlowApproval"));
const PembelianTanah = React.lazy(() => import("pages/PembelianTanah"));

const Prospek = React.lazy(() => import("pages/Prospek"));
const MasterNotaris = React.lazy(() => import("pages/MasterNotaris"));

const Neraca = React.lazy(() => import("pages/Laporan/Neraca"));
const LabaRugi = React.lazy(() => import("pages/Laporan/LabaRugi"));
const CashFlow = React.lazy(() => import("pages/Laporan/CashFlow"));
const Stok = React.lazy(() => import("pages/Laporan/Stok"));
const RincianPemasukanPengeluaran = React.lazy(() => import("pages/Laporan/PemasukanPengeluaran"));
const ArusKasBank = React.lazy(() => import("pages/Laporan/ArusKasBank"));
const ArusKasTunai = React.lazy(() => import("pages/Laporan/ArusKasTunai"));
const ArusKasBlokir = React.lazy(() => import("pages/Laporan/KasBankBlokir"));
const HutangBank = React.lazy(() => import("pages/Laporan/HutangBank"));
const Deposito = React.lazy(() => import("pages/Laporan/Deposito"));
const LaporanTransaksiPembelian = React.lazy(() => import("pages/Laporan/LaporanTransaksiPembelian"));
const LaporanPembangunanRumah = React.lazy(() => import("pages/Laporan/PembangunanRumah"));
const RekapKinerjaMarketing = React.lazy(() => import("pages/Laporan/RekapKinerjaMarketing"));
const MasterWilayah = React.lazy(() => import("pages/MasterWilayah"));
const MappingWilayah = React.lazy(() => import("pages/MappingWilayah"));
const PengajuanAbsensi = React.lazy(() => import("pages/PengajuanAbsensi"));

const MasterKaryawan = React.lazy(() => import("pages/MasterKaryawan"));
const MasterPihakKetiga = React.lazy(() => import("pages/MasterPihakKetiga"));
const PiutangKaryawan = React.lazy(() => import("pages/Laporan/PiutangKaryawan"));
const PiutangPihakKetiga = React.lazy(() => import("pages/Laporan/PiutangPihakKetiga"));
const MasterPemilikLahan = React.lazy(() => import("pages/MasterPemilikLahan"));
const MasterMandor = React.lazy(() => import("pages/MasterMandor"));
const MasterBank = React.lazy(() => import("pages/MasterBank"));
const MasterBankKPR = React.lazy(() => import("pages/MasterBankKpr"));
const HutangTanah = React.lazy(() => import("pages/Laporan/HutangTanah"));
const HutangMandor = React.lazy(() => import("pages/Laporan/HutangMandor"));
const LaporanHutangUser = React.lazy(() => import("pages/Laporan/HutangUser"));
const PersediaanTanah = React.lazy(() => import("pages/Laporan/PersediaanTanah"));
const PersediaanBangunan = React.lazy(() => import("pages/Laporan/PersediaanBangunan"));
const MasterHPP = React.lazy(() => import("pages/MasterHpp"));
const MasterPembangunan = React.lazy(() => import("pages/Pembangunan"));
const MasterPembentukanModal = React.lazy(() => import("pages/MasterPembentukanModal"));
const MasterHariLibur = React.lazy(() => import("pages/MasterHariLibur"));
const RekapAbsensi = React.lazy(() => import("pages/RekapAbsensi"));
const MasterUsers = React.lazy(() => import("pages/MasterUsers"));
const DataHold = React.lazy(() => import("pages/DataHold"));
const ProsesBerkas = React.lazy(() => import("pages/ProsesBerkas"));
const AkadKPR = React.lazy(() => import("pages/AkadKpr"));
const BookingUnit = React.lazy(() => import("pages/BookingUnit"));
const PelunasanDP = React.lazy(() => import("pages/PelunasanDP"));
const PencairanKpr = React.lazy(() => import("pages/PencairanKpr"));
const MasterTipeTransaksi = React.lazy(() => import("pages/MasterTipeTransaksi"));
const LaporanTanahBangunan = React.lazy(() => import("pages/Laporan/TanahBangunan"));
const LaporanKendaraan = React.lazy(() => import("pages/Laporan/Kendaraan"));
const LaporanInventarisKantor = React.lazy(() => import("pages/Laporan/InventarisKantor"));
const LaporanPenjualan = React.lazy(() => import("pages/Laporan/Penjualan"));
const LaporanAkadKPR = React.lazy(() => import("pages/Laporan/AkadKPR"));
const LaporanDajam = React.lazy(() => import("pages/Laporan/Dajam"));
const ProdukRumah = React.lazy(() => import("pages/MasterProdukRumah"));
const UnitDijual = React.lazy(() => import("pages/UnitDijual"));
const UserBatal = React.lazy(() => import("pages/UserBatal"));
const DaftarTunggu = React.lazy(() => import("pages/DaftarTunggu"));
const Absensi = React.lazy(() => import("pages/Absensi"));
const Siteplan = React.lazy(() => import("pages/Siteplan"));
// Halaman akun mandor (pekerjaan saya) — lihat juga penjaganya di routes/route.js
const PembangunanSaya = React.lazy(() => import("pages/PembangunanSaya"));
// Quality Control (Pengawas Cabang) + laporannya
const QualityControl = React.lazy(() => import("pages/QualityControl"));
const LaporanQualityControl = React.lazy(() => import("pages/Laporan/QualityControl"));
// Serah Terima Kunci (Pengawas Cabang/Admin) + laporannya
const SerahTerimaKunci = React.lazy(() => import("pages/SerahTerimaKunci"));
const LaporanSerahTerimaKunci = React.lazy(() => import("pages/Laporan/SerahTerimaKunci"));
// =========================================================================
//                       AUTH PROTECTED ROUTES
// =========================================================================

const authProtectedRoutes = [
  { path: "/dashboard", component: Dashboard },
  // Panduan bisa dibuka semua role, termasuk Mandor (lihat routes/route.js).
  { path: "/panduan", component: Panduan },
  // Akun mandor diarahkan ke sini (lihat routes/route.js & Login.js)
  { path: "/pembangunan-saya", component: PembangunanSaya },
  { path: "/quality-control", component: QualityControl },
  { path: "/laporan-qc", component: LaporanQualityControl },
  { path: "/serah-terima-kunci", component: SerahTerimaKunci },
  { path: "/laporan-serah-terima-kunci", component: LaporanSerahTerimaKunci },
  { path: "/dashboard-saas", component: DashboardSaas },
  { path: "/dashboard-crypto", component: DashboardCrypto },
  { path: "/blog", component: Blog },
  { path: "/dashboard-job", component: DashboardJob },

  //Crypto
  { path: "/crypto-wallet", component: CryptoWallet },
  { path: "/crypto-buy-sell", component: CryptoBuySell },
  { path: "/crypto-exchange", component: CryptoExchange },
  { path: "/crypto-lending", component: CryptoLending },
  { path: "/crypto-orders", component: CryptoOrders },
  { path: "/crypto-kyc-application", component: CryptoKYCApplication },

  //chat
  { path: "/chat", component: Chat },

  //File Manager
  { path: "/apps-filemanager", component: FileManager },

  // //calendar
  { path: "/calendar", component: Calendar },

  // //profile
  { path: "/profile", component: UserProfile },

  //Ecommerce
  { path: "/ecommerce-product-detail/:id", component: EcommerceProductDetail },
  { path: "/ecommerce-products", component: EcommerceProducts },
  { path: "/ecommerce-orders", component: EcommerceOrders },
  { path: "/ecommerce-customers", component: EcommerceCustomers },
  { path: "/ecommerce-cart", component: EcommerceCart },
  { path: "/ecommerce-checkout", component: EcommerceCheckout },
  { path: "/ecommerce-shops", component: EcommerceShops },
  { path: "/ecommerce-add-product", component: EcommerceAddProduct },

  //Email
  { path: "/email-inbox", component: EmailInbox },
  { path: "/email-read/:id?", component: EmailRead },
  { path: "/email-template-basic", component: EmailBasicTemplte },
  { path: "/email-template-alert", component: EmailAlertTemplte },
  { path: "/email-template-billing", component: EmailTemplateBilling },

  //Invoices
  { path: "/invoices-list", component: InvoicesList },
  { path: "/invoices-detail/:id", component: InvoiceDetail },
  { path: "/invoices-detail", component: InvoiceDetail },

  // Tasks
  { path: "/tasks-list", component: TasksList },
  { path: "/tasks-create", component: TasksCreate },
  { path: "/tasks-kanban", component: TasksKanban },

  //Projects
  { path: "/projects-grid", component: ProjectsGrid },
  { path: "/projects-list", component: ProjectsList },
  { path: "/projects-overview", component: ProjectsOverview },
  { path: "/projects-overview/:id", component: ProjectsOverview },
  { path: "/projects-create", component: ProjectsCreate },
  { path: "/project-detail", component: ProjectDetail }, // ProjectDetail ditambahkan

  //Blog
  { path: "/blog-list", component: BlogList },
  { path: "/blog-grid", component: BlogGrid },
  { path: "/blog-details", component: BlogDetails },

  //job
  { path: "/job-grid", component: JobGrid },
  { path: "/job-details", component: JobDetails },
  { path: "/job-categories", component: JobCategories },
  { path: "/job-list", component: JobList },
  { path: "/job-apply", component: ApplyJobs },
  { path: "/candidate-list", component: CandidateList },
  { path: "/candidate-overview", component: CandidateOverview },

  //video
  { path: "/video-list", component: VideoList },

  //bacaan
  { path: "/bacaan-list", component: BacaanList },

  //Rekening
  { path: "/rekening", component: RekeningBank },

  //Supplier
  { path: "/supplier", component: Supplier },

  //Supir
  { path: "/supir", component: Supir },
  { path: "/absensi", component: Absensi },

  //produk
  { path: "/produk", component: Product },

  //penjualan
  { path: "/penjualan", component: Penjualan },
  { path: "/penjualan/add", component: PenjualanLangsung },

  //stok mutasi
  { path: "/stok-mutasi", component: StockMutasi },

  //paket simulasi
  { path: "/paket-tryout", component: PaketSimulasi },

  //raport tryout
  { path: "/raport-nasional", component: PaketRaportNasional },
  { path: "/sub-paket-raport", component: SubPaketRaport },
  { path: "/rank-nasional", component: RiwayatRaport },

  { path: "/sub-paket", component: SubSimulasiDetail },
  { path: "/sub-paket-video", component: SubVideoDetail },
  { path: "/paket-details", component: PaketDetails },

  { path: "/master-kategori", component: Kategori },

  { path: "/master-tipe-transaksi", component: MasterTipeTransaksi },

  { path: "/paket-simulasi", component: PaketSimulasi },
  { path: "/paket-kuis", component: PaketSimulasi },
  { path: "/paket-belajar", component: PaketSimulasi },
  { path: "/master-tipe-konten", component: MasterTipeKonten },

  { path: "/prospek", component: Prospek },

  { path: "/master-users", component: MasterUsers },

  { path: "/master-notaris", component: MasterNotaris },

  { path: "/master-lokasi", component: MasterLokasi },

  { path: "/master-blok", component: MasterBlok },

  { path: "/master-wilayah", component: MasterWilayah },

  { path: "/master-bank-kpr", component: MasterBankKPR },

  //pembahasan
  { path: "/paket-pembahasan", component: PaketSimulasi },

  { path: "/materi-bacaan", component: PaketBacaan },
  { path: "/detail-bacaan", component: PaketDetailBacaan },
  { path: "/list-bacaan", component: ListBacaan },
  { path: "/sub-paket-bacaan", component: SubPaketBacaan },

  //video
  { path: "/paket-video", component: PaketVideo },
  { path: "/detail-video", component: PaketDetailVideo },
  { path: "/list-video", component: ListVideo },

  //rekaman kelas
  { path: "/paket-rekaman", component: PaketVideo },

  //produk
  { path: "/list-produk", component: Produk },
  { path: "/detail-produk", component: DetailProduk },
  { path: "/produk-konten", component: ProdukKonten },

  //Master
  { path: "/master-paket", component: MasterPaket },
  { path: "/produk-rumah", component: ProdukRumah },
  { path: "/master-jenis-seleksi", component: JenisSeleksi },
  { path: "/master-fase-ujian", component: FaseUjian },
  { path: "/master-jenis-soal", component: MasterJenisSoal},

  //detail tryout
  { path: "/paket-detail-tryout", component: PaketDetailTryout },

  { path: "/data-hold", component: DataHold },

  { path: "/laporan-penjualan", component: LaporanPenjualan },
  { path: "/rekap-kinerja-marketing", component: RekapKinerjaMarketing },
  { path: "/laporan-akad-kpr", component: LaporanAkadKPR },
  { path: "/laporan-stok", component: Stok },
  { path: "/laporan-dajam", component: LaporanDajam },

  { path: "/proses-berkas", component: ProsesBerkas },

  //jabatan
  { path: "/master-jabatan", component: Jabatan },

  //tipe jurnal
  { path: "/master-tipe-jurnal", component: TipeJurnal },

  //tipe jurnal
  { path: "/master-bagan-akun", component: Coa },

  //master jurnal
  { path: "/master-jurnal", component: MasterJurnalLayout },
  

  { path: "/mapping-akun", component: CoaDivisiMapping },

  { path: "/booking-unit", component: BookingUnit },
  { path: "/pelunasan-dp", component: PelunasanDP },
  { path: "/pencairan-kpr", component: PencairanKpr },
  { path: "/akad-kpr", component: AkadKPR },

  { path: "/mapping-wilayah", component: MappingWilayah },

  //jurnal umum
  { path: "/jurnal-umum", component: JurnalUmumLayout },

  { path: "/master-workflow-approval", component: MasterWorkFlowApproval },

  // ✅ PERBAIKAN: Menggunakan nama Lazy Loaded yang sudah diselaraskan
  { path: "/jurnal-saldo-awal", component: JurnalSaldoAwalPage }, 

  { path: "/master-divisi", component: Divisi },

  { path: "/master-karyawan", component: MasterKaryawan },

  { path: "/master-pihak-ketiga", component: MasterPihakKetiga },

  { path: "/pemilik-lahan", component: MasterPemilikLahan },

  { path: "/master-mandor", component: MasterMandor },

  { path: "/master-bank", component: MasterBank },
  
  { path: "/pengajuan-transaksi", component: Pengajuan },
  //soal
  { path: "/soal-list", component: SoalList },
  { path: "/jenis-soal", component: JenisSoal },

  //laporan
  { path: "/neraca", component: Neraca },
  { path: "/laba-rugi", component: LabaRugi },
  { path: "/cash-flow", component: CashFlow },
  { path: "/rincian-pemasukan-pengeluaran", component: RincianPemasukanPengeluaran },
  { path: "/arus-kas-bank", component: ArusKasBank },
  { path: "/arus-kas-tunai", component: ArusKasTunai },
  { path: "/kas-bank-blokir", component: ArusKasBlokir },
  { path: "/hutang-bank", component: HutangBank },
  { path: "/deposito", component: Deposito },
  { path: "/laporan-pembelian-tanah", component: LaporanTransaksiPembelian },
  { path: "/laporan-pembangunan-rumah", component: LaporanPembangunanRumah },
  { path: "/laporan-tanah-bangunan", component: LaporanTanahBangunan },
  { path: "/laporan-kendaraan", component: LaporanKendaraan },
  { path: "/laporan-inventaris-kantor", component: LaporanInventarisKantor },
  { path: "/piutang-karyawan", component: PiutangKaryawan },
  { path: "/piutang-pihak-ketiga", component: PiutangPihakKetiga },

{ path: "/hutang-tanah", component: HutangTanah },
{ path: "/hutang-mandor", component: HutangMandor },
{ path: "/laporan-hutang-user", component: LaporanHutangUser },
{ path: "/persediaan-tanah", component: PersediaanTanah },
{ path: "/persediaan-bangunan", component: PersediaanBangunan },

  //langganan
  { path: "/langganan-tryout", component: PaketLanggananTryout },
  { path: "/sub-paket-langganan", component: SubPaketLangganan },
  { path: "/jenis-soal", component: JenisSoal },

  { path: "/pembelian-tanah", component: PembelianTanah },

  { path: "/paket-langganan", component: PaketLangganan },
  { path: "/produk-rumah", component: PaketBimbel },

  { path: "/unit-dijual", component: UnitDijual },



  { path: "/user", component: User },
  { path: "/payments", component: Payments },
  { path: "/pengaturan-profil", component: UpdateUser },
  
  //kelas online
  { path: "/kelas-online", component: KelasOnline },
  { path: "/kelas-online-user", component: UserKelasOnline },

  // Contacts
  { path: "/contacts-grid", component: ContactsGrid },
  { path: "/contacts-list", component: ContactsList },
  { path: "/contacts-profile", component: ContactsProfile },

  //Charts
  { path: "/apex-charts", component: ChartApex },
  { path: "/chartjs-charts", component: ChartjsChart },
  { path: "/e-charts", component: EChart },
  { path: "/sparkline-charts", component: SparklineChart },
  { path: "/charts-knob", component: ChartsKnob },
  { path: "/re-charts", component: ReCharts },

  // Icons
  { path: "/icons-boxicons", component: IconBoxicons },
  { path: "/icons-dripicons", component: IconDripicons },
  { path: "/icons-materialdesign", component: IconMaterialdesign },
  { path: "/icons-fontawesome", component: IconFontawesome },

  // Tables
  { path: "/tables-basic", component: BasicTables },
  { path: "/tables-datatable", component: DatatableTables },

  // Maps
  { path: "/maps-google", component: MapsGoogle },

  // Forms
  { path: "/form-elements", component: FormElements },
  { path: "/form-layouts", component: FormLayouts },
  { path: "/form-advanced", component: FormAdvanced },
  { path: "/form-editors", component: FormEditors },
  { path: "/form-mask", component: FormMask },
  { path: "/form-repeater", component: FormRepeater },
  { path: "/form-uploads", component: FormUpload },
  { path: "/form-wizard", component: FormWizard },
  { path: "/form-validation", component: FormValidations },
  { path: "/master-hpp", component: MasterHPP },

  // Ui
  { path: "/ui-alerts", component: UiAlert },
  { path: "/ui-buttons", component: UiButtons },
  { path: "/ui-cards", component: UiCards },
  { path: "/ui-carousel", component: UiCarousel },
  { path: "/ui-colors", component: UiColors },
  { path: "/ui-dropdowns", component: UiDropdown },
  { path: "/ui-general", component: UiGeneral },
  { path: "/ui-grid", component: UiGrid },
  { path: "/ui-images", component: UiImages },
  { path: "/ui-lightbox", component: UiLightbox },
  { path: "/ui-modals", component: UiModal },
  { path: "/ui-progressbars", component: UiProgressbar },
  { path: "/ui-tabs-accordions", component: UiTabsAccordions },
  { path: "/ui-typography", component: UiTypography },
  { path: "/ui-video", component: UiVideo },
  { path: "/ui-session-timeout", component: UiSessionTimeout },
  { path: "/ui-rating", component: UiRating },
  { path: "/ui-rangeslider", component: UiRangeSlider },
  { path: "/ui-notifications", component: UiNotifications },
  { path: "/ui-offcanvas", component: UiOffCanvas },
  { path: "/ui-utilities", component: UiUtilitie },
  { path: "/ui-placeholders", component: UiPlaceholders },
  { path: "/ui-toasts", component: UiToasts },

  //Utility
  { path: "/pages-starter", component: PagesStarter },
  { path: "/pages-timeline", component: PagesTimeline },
  { path: "/pages-faqs", component: PagesFaqs },
  { path: "/pages-pricing", component: PagesPricing },
  { path: "/master-pembangunan", component: MasterPembangunan },
  { path: "/pembentukan-modal", component: MasterPembentukanModal },
  { path: "/master-hari-libur", component: MasterHariLibur },
  { path: "/rekap-absensi", component: RekapAbsensi },
  { path: "/pengajuan-absensi", component: PengajuanAbsensi },
  { path: "/user-batal", component: UserBatal },
  { path: "/daftar-tunggu", component: DaftarTunggu },
  { path: "/siteplan", component: Siteplan },

  // Route Default
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
];

// =========================================================================
//                       PUBLIC ROUTES
// =========================================================================

const publicRoutes = [
  { path: "/login", component: Login },
  { path: "/logout", component: Logout },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/register", component: Register },
  { path: "/reset-password", component: ResetPassword },
  { path: "/user/verifikasi", component: KonfirmasiEmail },

  { path: "/pages-maintenance", component: PagesMaintenance },
  { path: "/pages-comingsoon", component: PagesComingsoon },
  { path: "/pages-404", component: Pages404 },
  { path: "/pages-500", component: Pages500 },
  { path: "/crypto-ico-landing", component: CryptoIcoLanding },

  // Authentication Inner
  { path: "/pages-login", component: Login1 },
  { path: "/pages-login-2", component: Login2 },
  { path: "/pages-register", component: Register1 },
  { path: "/pages-register-2", component: Register2 },
  { path: "/page-recoverpw", component: Recoverpw },
  { path: "/page-recoverpw-2", component: Recoverpw2 },
  { path: "/pages-forgot-pwd", component: ForgetPwd1 },
  { path: "/auth-forgot-pwd-2", component: ForgetPwd2 },
  { path: "/auth-lock-screen", component: LockScreen },
  { path: "/auth-lock-screen-2", component: LockScreen2 },
  { path: "/page-confirm-mail", component: ConfirmMail },
  { path: "/page-confirm-mail-2", component: ConfirmMail2 },
  { path: "/auth-email-verification", component: EmailVerification },
  { path: "/auth-email-verification-2", component: EmailVerification2 },
  { path: "/auth-two-step-verification", component: TwostepVerification },
  { path: "/auth-two-step-verification-2", component: TwostepVerification2 },
  { path: "/verifikasi-email", component: VerifikasiEmail },
  { path: "/verifikasi-email-reset", component: VerifikasiEmailReset },
];

export { authProtectedRoutes, publicRoutes };